import { EvaluationParametersFields } from '../EvaluationParametersFields';
import type { IProfessorAreaEvaluationsList } from 'interfaces/professor_area/evaluations';

interface ModalCreateEvaluationStep2Props {
  classroomEvaluations: IProfessorAreaEvaluationsList[];
  evaluationsLoading: boolean;
  /** Quando true, esconde tipo (kind), peso e prévia — fluxo de substitutiva. */
  isReplacement?: boolean;
}

export const ModalCreateEvaluationStep2 = ({
  classroomEvaluations,
  evaluationsLoading,
  isReplacement
}: ModalCreateEvaluationStep2Props) => (
  <EvaluationParametersFields
    entity="assessment"
    classroomEvaluations={classroomEvaluations}
    evaluationsLoading={evaluationsLoading}
    isReplacement={isReplacement}
  />
);
